import { AXIOS_INSTANCE_CONNECT } from "@/lib/axios";
import type { AxiosRequestConfig } from "axios";

export const connectCustomInstance = async <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig
): Promise<T> => {
  const controller = new AbortController();

  const promise = AXIOS_INSTANCE_CONNECT({
    ...config,
    ...options,
  }).then(({ data }: { data: T }) => data);

  controller.abort();

  return promise;
};
